class DraggableElement {
    constructor(element, elementForDragOnMousedown, top, left) {
        this.element = element;
        this.top = top;
        this.left = left;
        this.elementForDragOnMousedown = elementForDragOnMousedown;

        this.pos1 = 0; //E' la differenza tra la nuova posizione X del mouse e la vecchia
        this.pos2 = 0; //E' la differenza tra la nuova posizione Y del mouse e la vecchia
        this.pos3 = 0; //E' la posizione X del mouse
        this.pos4 = 0; //E' la posizione Y del mouse

        this.mouseX_relativeToElement = 0;
        this.mouseY_relativeToElement = 0;

        this.dragMouseDownBinded = this.dragMouseDown.bind(this);
        this.elementDragBinded = this.elementDrag.bind(this);

        //INIT
        this.dragElement();
    }

    //METHODS
    dragElement() {
        this.elementForDragOnMousedown.addEventListener("mousedown", e => {
            this.dragMouseDownBinded(e);
        });
    }

    dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();

        this.pos3 = e.clientX;
        this.pos4 = e.clientY;

        this.mouseX_relativeToElement = e.clientX - this.element.offsetLeft;
        this.mouseY_relativeToElement = e.clientY - this.element.offsetTop;

        //MOUSE MOVE
        this.addMouseMoveListener();

        //MOUSE UP
        document.addEventListener("mouseup", () => {
            this.removeMouseMoveListener();
        });
    }

    elementDrag(e) {
        e = e || window.event;
        e.preventDefault();

        //Si effettuano operazioni solo se la posizione del lato destro del Draggable non supera il lato destro della finestra del browser oppure il lato sinistro del Draggable non supera il lato sinistro della finestra del browser
        if (this.element.offsetLeft - (this.pos3 - e.clientX) >= 0 && this.element.offsetLeft + this.element.offsetWidth - (this.pos3 - e.clientX) <= window.innerWidth) {
            // calculate the new cursor position:
            this.pos1 = this.pos3 - e.clientX;
            this.pos3 = e.clientX;

            if (this.element.offsetLeft - this.pos1 > 0 && this.element.offsetLeft + this.element.offsetWidth - this.pos1 < window.innerWidth) {
                this.element.style.left = `${this.element.offsetLeft - this.pos1}px`;
            }
        } else {
            this.pos3 = this.element.offsetLeft + this.mouseX_relativeToElement;

            if (this.element.offsetLeft - (this.pos3 - e.clientX) < 0) {
                this.element.style.left = "0px";
            }

            if (this.element.offsetLeft + this.element.offsetWidth - (this.pos3 - e.clientX) > window.innerWidth) {
                this.element.style.left = `${window.innerWidth - this.element.offsetWidth}px`;
            }
        }

        //CASO PER LA Y
        if (this.element.offsetTop - (this.pos4 - e.clientY) >= 0 && this.element.offsetTop + this.element.offsetHeight - (this.pos4 - e.clientY) <= window.innerHeight) {
            // calculate the new cursor position:
            this.pos2 = this.pos4 - e.clientY;
            this.pos4 = e.clientY;

            if (this.element.offsetTop - this.pos2 > 0 && this.element.offsetTop + this.element.offsetHeight - this.pos2 < window.innerHeight) {
                this.element.style.top = `${this.element.offsetTop - this.pos2}px`;
            }
        } else {
            this.pos4 = this.element.offsetTop + this.mouseY_relativeToElement;

            if (this.element.offsetTop - (this.pos4 - e.clientY) < 0) {
                this.element.style.top = "0px";
            }

            if (this.element.offsetTop + this.element.offsetHeight - (this.pos4 - e.clientY) > window.innerHeight) {
                this.element.style.top = `${window.innerHeight - this.element.offsetHeight}px`;
            }
        }
    }

    addMouseMoveListener() {
        document.addEventListener("mousemove", this.elementDragBinded);
    }

    removeMouseMoveListener() {
        document.removeEventListener("mousemove", this.elementDragBinded, false);
    }
}

//CLASSE PER IL RESIZE DI UN ELEMENTO
class Resizable {
    constructor(element) {
        this.element = element;
        this.cornerIcon = null;

        //Binded
        this.initResizeBinded = this.initResize.bind(this);
        this.ResizeBinded = this.Resize.bind(this);
        this.stopResizeBinded = this.stopResize.bind(this);

        //Init
        this.createCornerIcon();
    }

    createCornerIcon() {
        let cornerIcon = document.createElement("div");
        cornerIcon.classList.add("resizable-corner-icon");

        let iconSvgCode = `
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 301.41 301.41">
                <path class="resize-corner-icon-svg" d="M72.5,300.5" transform="translate(0.71 0.71)" />
                <path class="resize-corner-icon-svg" d="M98.5,289.5" transform="translate(0.71 0.71)" />
                <path class="resize-corner-icon-svg" d="M139.5,291.5" transform="translate(0.71 0.71)" />
                <path class="resize-corner-icon-svg" d="M125.5,300.5" transform="translate(0.71 0.71)" />
                <path class="resize-corner-icon-svg" d="M23.51,277.49" transform="translate(0.71 0.71)" />
                <line class="resize-corner-icon-svg" x1="0.71" y1="300.71" x2="300.71" y2="0.71" />
                <path class="resize-corner-icon-svg" d="M98.5,300.5" transform="translate(0.71 0.71)" />
                <path class="resize-corner-icon-svg" d="M93.11,295" transform="translate(0.71 0.71)" />
                <path class="resize-corner-icon-svg" d="M119.11,284" transform="translate(0.71 0.71)" />
                <path class="resize-corner-icon-svg" d="M160.11,286" transform="translate(0.71 0.71)" />
                <path class="resize-corner-icon-svg" d="M146.11,295" transform="translate(0.71 0.71)" />
                <path class="resize-corner-icon-svg" d="M44.13,272" transform="translate(0.71 0.71)" />
                <line class="resize-corner-icon-svg" x1="200.71" y1="300.71" x2="300.71" y2="200.71" />
                <path class="resize-corner-icon-svg" d="M119.11,295" transform="translate(0.71 0.71)" />
                <line class="resize-corner-icon-svg" x1="100.71" y1="300.71" x2="300.71" y2="100.71" />
            </svg>
        `;

        cornerIcon.insertAdjacentHTML("beforeend", iconSvgCode);
        this.element.appendChild(cornerIcon);

        this.cornerIcon = cornerIcon;
        this.cornerIcon.addEventListener("mousedown", e => {
            this.initResizeBinded(e);
        });
    }

    initResize(e) {
        e.preventDefault();
        window.addEventListener('mousemove', this.ResizeBinded, false);
        window.addEventListener('mouseup', this.stopResizeBinded, false);
    }

    //resize the element
    Resize(e) {
        if (e.clientX <= window.innerWidth) {
            this.element.style.width = `${e.clientX - this.element.offsetLeft}px`;
        }

        if (e.clientY <= window.innerHeight) {
            this.element.style.height = `${e.clientY - this.element.offsetTop}px`;
        }
    }
    //on mouseup remove windows functions mousemove & mouseup
    stopResize() {
        window.removeEventListener('mousemove', this.ResizeBinded, false);
        window.removeEventListener('mouseup', this.stopResizeBinded, false);
    }
}

export function setDraggable(id) {
	const draggable = document.getElementById(id);
	new DraggableElement(draggable, draggable.getElementsByClassName("finestra-stampa-ticket-intestazione")[0], 0, 0);
}

export function setResizable(id) {
	const resizable = document.getElementById(id);
	new Resizable(resizable);
}
